import React from "react";
import Slider from "react-slick";
import SingleProjectScroll from "./SingleProjectScroll";
import "./style.css";
import PropTypes from "prop-types";

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
      </svg>
    </div>
  );
}

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
      </svg>
    </div>
  );
}

const ProjectsList = ({ projects, isAdditionalBg, lang, isHorizontal }) => {

  const projectsToDisplay =
    projects && projects.length
      ? projects
          .filter((a) => {
            if (!a.name) {
              return;
            }
            return !a.name.toLowerCase().includes("sasaboe")
          })
          .sort((a, b) => a.rank - b.rank)
      : [];

  const settings = {
    dots: true,
    slidesToShow: projectsToDisplay?.length >= 3 ? 3 : projectsToDisplay?.length,
    slidesToScroll: 3,
    infinite: false,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: projectsToDisplay?.length >= 3 ? 2 : projectsToDisplay?.length,
          slidesToScroll: projectsToDisplay?.length >= 3 ? 2 : projectsToDisplay?.length,
        }
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ],
  };

  return (
    <section>
      <link rel="stylesheet" type="text/css" charSet="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
      <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />

      <Slider {...settings}>
        {projectsToDisplay
          ? projectsToDisplay.map((project) => (
            <div
              className={`project-wrapper ${projectsToDisplay?.length < 2 ? isHorizontal ? '' : 'mw-400' : ''}`}
              key={project.shortDescription}
            >
              <SingleProjectScroll isHorizontal={isHorizontal} isAdditionalBg={isAdditionalBg} project={project} lang={lang} />
            </div>
            ))
          : ""}
      </Slider>

    </section>
  );
};

ProjectsList.propTypes = {
  projects: PropTypes.array,
};

export default ProjectsList;
